import { StorageService } from '../../shared/storage';
import { ConsentKey } from './types';

type ConsentStorageItem = string;

export default class ConsentStorage extends StorageService<ConsentStorageItem> {

    private static instance?: ConsentStorage;

    private constructor() {
        super('consent');
    }

    public static getInstance() {
        if (!this.instance) {
            this.instance = new ConsentStorage();
        }

        return this.instance;
    }

    public setConsent(consentKey: ConsentKey, value: boolean) {
        this.setItem<boolean>(`consent-${ consentKey }`, value);
    }

    public getConsent(consentKey: ConsentKey) {
        return this.getItem<boolean>(`consent-${ consentKey }`);
    }

}
